<template>
  <div class="grid_menu mb-5 pl-2">
    <v-card class="menu_team text-center">
      <router-link class="menu_team_link" to="/stock/document/governmentreceipt">
        <div class="menu_team_img">
          <img src="@/assets/formnew.png">
        </div>
        <div>
          สร้างใบส่งคืนสินค้าใหม่
        </div>
      </router-link>
    </v-card>
    <v-card class="menu_team text-center">
      <router-link class="menu_team_link" to="/stock/document/returnproductreceipt">
        <div class="menu_team_img">
          <img src="@/assets/recycled-paper_1.png">
        </div>
        <div>
          ใบส่งคืนสินค้า (รอการอัพเดท)
        </div>
      </router-link>
    </v-card>
    <v-card class="menu_team text-center">
      <router-link class="menu_team_link" to="/stock/document/documentreducedebt">
        <div class="menu_team_img">
          <img src="@/assets/checklist.png">
        </div>
        <div>
          ใบส่งคืนสินค้า (ลดหนี้แล้ว)
        </div>
      </router-link>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "MenuDocument"
}
</script>

<style scoped>
.grid_menu {
  display: grid;
  grid-template-columns: 33.33% 33.33% 33.33%;
  grid-gap: 15px 0;
}

@media only screen and (max-width: 700px) {
  .grid_menu {
    display: grid;
    grid-template-columns: 50% 50%;
  }
}
@media only screen and (max-width: 500px) {
  .grid_menu {
    display: grid;
    grid-template-columns: 100%;
  }
}
.menu_team{
  width: 97%;
}
.menu_team>.menu_team_link {
  color: #565656;
  padding: 10px 15px 10px 15px;
  line-height: 1.45;
  transition: padding 0.35s ease 0s !important;
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  outline: none;
  background-color: transparent;
  border-radius: 4px;
  text-decoration: none;
  font-size: 20px;
}
.router-link-active,
.menu_team>.menu_team_link:hover {
  color: #fff !important;
  background-image: linear-gradient(to right, #8cc63e, #91c657, #9cc66d)!important;
  transition: 0.1s !important;
  border-radius: 4px;
  font-weight: 400;
  height: 100%;
}

.menu_team_img {
  margin: auto;
  width: 50px;
}

.menu_team_img>img {
  max-width: 100%;
}
</style>
